import { useEffect, useRef } from 'react';
import { Box, useOnClickOutside } from '@alf/uikit';
import { InfiniteLoader } from '@namespace/common';
import { useDeviceStore } from '@namespace/device';
import { useFetchNotificationsList } from '../../hooks';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../store';
import { EmptyState } from '../EmptyState';
import { Notification } from '../Notification';
import { NotificationListHeader } from '../NotificationListHeader';

import styles from './index.module.css';

const { SET_IS_NOTIFICATIONS_LIST_OPENED } = notificationCenterActions;

export const NotificationsList = ({ bellRef }) => {
  const { notifications, isLoadingNotifications, isNotificationsListOpened } =
    useNotificationCenterStore([
      'notifications',
      'isLoadingNotifications',
      'isNotificationsListOpened'
    ]);

  const rootRef = useRef();
  const { loadMore } = useFetchNotificationsList();
  const { isDesktop } = useDeviceStore();

  useOnClickOutside(
    () => SET_IS_NOTIFICATIONS_LIST_OPENED(false),
    rootRef,
    bellRef
  );

  useEffect(() => {
    if (isNotificationsListOpened && !isDesktop) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isNotificationsListOpened, isDesktop]);

  return (
    <Box direction="column" className={styles.root} ref={rootRef}>
      <NotificationListHeader />
      {notifications.length > 0 ? (
        <InfiniteLoader
          onLoadMore={loadMore}
          isLoading={isLoadingNotifications}
          className={styles.list}
        >
          {notifications.map((notification) => (
            <Notification
              key={notification.notificationId}
              notification={notification}
              className={styles.notification}
            />
          ))}
        </InfiniteLoader>
      ) : (
        <EmptyState />
      )}
    </Box>
  );
};
